import { type BankAccountAttributes, type InvestmentAccountAttributes, BankAccountType } from '@egw/api'
import { useTranslation } from '@egw/i18n'
import { Currency } from '@egw/utils'
import { type FC, useEffect, useState } from 'react'
import { useTransferContextProvider } from '../../context'
import { checkIfBankAccount } from '../../utils'

export const MinDepositCard: FC = () => {
  const { t } = useTranslation('features-transfer')

  const { displaySuccess, toFieldOption, allFieldOptions } = useTransferContextProvider()

  const [minimumAttributes, setMinimumAttributes] = useState<
    BankAccountAttributes | InvestmentAccountAttributes | undefined
  >(undefined)

  useEffect(() => {
    // FIND BANK ACCOUNT IN ATTRIBUTES (CHECKING | SAVING) WITH minimumDepositMet = false
    const bankAccountTypeMinExists = allFieldOptions.find((account) =>
      Boolean(
        account.accountType === BankAccountType.HIGH_YIELD_CHECKING && account.attributes?.minimumDepositMet === false,
      ),
    )
    // If toFieldOption is not selected and bankAccountTypeMinExists, show FAQ and set the minimum attributes
    if (!toFieldOption.value && !bankAccountTypeMinExists?.attributes?.minimumDepositMet) {
      setMinimumAttributes(bankAccountTypeMinExists?.attributes as BankAccountAttributes)
      return
    }

    // Find minimum attributes for selected toFieldOption
    if (toFieldOption.value) {
      // If toFieldOption is selected, check type of account to ensure showing for FAQ
      const chosenAccountMinNotMet = allFieldOptions.find(
        (account) => account.alias === toFieldOption.alias && account.attributes?.minimumDepositMet === false,
      )
      chosenAccountMinNotMet && setMinimumAttributes(chosenAccountMinNotMet.attributes)
      return
    }
    // Reset state if no minimum attributes are found
    setMinimumAttributes(undefined)
  }, [allFieldOptions, toFieldOption])

  return minimumAttributes?.minimumDeposit && !displaySuccess ? (
    <div className="mb-8 flex w-full justify-center">
      <div className="flex flex-col items-start justify-between bg-sky-50 py-4 px-8 gap-3 w-full">
        <div className="col flex flex-col gap-1">
          <p className="text-sky-600 text-xs font-bold">{t('transfer.fund_card_title')}</p>
          <p className="text-sm text-sky-700">
            {t('transfer.fund_card_body_wealth', {
              minDeposit: Currency.integerCents.onlyMinus(minimumAttributes.minimumDeposit ?? 0),
            })}
          </p>
        </div>
      </div>
    </div>
  ) : null
}
